import { Link } from 'react-router-dom'
import { FactoryLogo, FactoryWordmark } from './FactoryLogo'
import { TynHubByline } from './TynHubByline'
import { useAuth } from '../contexts/AuthContext'

export function PublicNavBar() {
  const { isAuthenticated } = useAuth()

  return (
    <div className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900">
      <div className="flex items-center gap-2">
        <Link to={isAuthenticated ? '/dashboard' : '/'} className="flex items-center gap-2 hover:opacity-80 transition-opacity">
          <FactoryLogo className="w-7 h-7" />
          <span className="hidden sm:inline">
            <FactoryWordmark className="h-4" />
          </span>
        </Link>
        <TynHubByline className="hidden sm:inline" />
      </div>
      <div className="flex items-center gap-2 sm:gap-4">
        <Link to="/products" className="text-sm text-gray-500 hover:text-gray-900 dark:hover:text-gray-100 transition-colors hidden sm:inline">
          Products
        </Link>
        <Link to="/pricing" className="text-sm text-gray-500 hover:text-gray-900 dark:hover:text-gray-100 transition-colors hidden sm:inline">
          Pricing
        </Link>
        <Link to="/packages" className="text-sm text-gray-500 hover:text-gray-900 dark:hover:text-gray-100 transition-colors hidden sm:inline">
          Packages
        </Link>
        <Link to="/estimate" className="text-sm text-gray-500 hover:text-gray-900 dark:hover:text-gray-100 transition-colors hidden sm:inline">
          Estimate
        </Link>
        <Link to="/blog" className="text-sm text-gray-500 hover:text-gray-900 dark:hover:text-gray-100 transition-colors hidden sm:inline">
          Blog
        </Link>
        <Link to="/getting-started" className="text-sm text-gray-500 hover:text-gray-900 dark:hover:text-gray-100 transition-colors hidden sm:inline">
          Docs
        </Link>
        {isAuthenticated ? (
          <Link
            to="/dashboard"
            className="px-3 sm:px-4 py-1.5 bg-primary-600 text-white text-sm font-medium rounded-lg hover:bg-primary-500 transition-colors"
          >
            Dashboard
          </Link>
        ) : (
          <>
            <Link to="/login" className="text-sm text-gray-500 hover:text-gray-900 dark:hover:text-gray-100 transition-colors">
              Sign in
            </Link>
            <Link
              to="/register"
              className="px-3 sm:px-4 py-1.5 bg-primary-600 text-white text-sm font-medium rounded-lg hover:bg-primary-500 transition-colors"
            >
              Get Started
            </Link>
          </>
        )}
      </div>
    </div>
  )
}
